import React, { useState } from "react";
import Select from "../../../form/Select";
import Switch from "../../../form/Switch";
import Input from "../../../form/Input";
import DatePicker from "../../../form/DatePicker";
import OrderItem from "../../../single-items/OrderItem";
import Search from "../../../form/Search";
import { handleFilterChange } from "../../../../helpers";
import NodataImage from "../../../../assets/images/no-results-bg.2d2c6ee3.png";
import Image from "../../../elements/Image";

const OrderListing = ({
  title,
  data,
  isLoading = false,
  isSort = false,
  isfilter = false,
  status,
  sort,
  deliveryStatus,
  dateRange,
  filterOn,
  setFilterOn = () => {},
  setKeyword = () => {},
  setFilters = () => {},
  setStatus = () => {},
  setDeliveryStatus = () => {},
  setSort = () => {},
  setDateRange = () => {},
}) => {
  // const [dateRange, setDateRange] = useState({
  //   startDate: null,
  //   endDate: null,
  // });
  //  const [sort, setSort] = useState("Desc");
  // const [status, setStatus] = useState("All");
  // const [deliveryStatus, setDeliveryStatus] = useState("All");

  return (
    <>
      <div className="relative bg-white py-4 px-4 shadow shadow-md-pink/20 rounded-lg">
        <div className="mb-4 pb-4 border-b border-md-pink-light-1 flex items-center justify-between gap-4 flex-wrap">
          <div className="text-lg 2xl:text-xl text-md-dark font-semibold">
            {title}
          </div>
          {(isSort || isfilter) && (
            <div className="ml-auto flex items-center gap-x-4 flex-shrink-0">
              {isfilter && (
                <div className="flex items-center gap-1 md:gap-2">
                  <div className="font-medium text-md-dark text-sm">
                    Filters
                  </div>
                  <Switch
                    checked={filterOn}
                    onChange={() => setFilterOn(!filterOn)}
                  />
                </div>
              )}
              {isSort && (
                <Select
                  xPlacement={"bottomRight"}
                  selectedValue={sort}
                  dropdownData={[
                    { name: "Newest First", value: "-createdAt" },
                    { name: "Oldest First", value: "createdAt" },
                    // { name: "Alphabetical (A-Z)", value: "collectionName" },
                    // { name: "Alphabetical (Z-A)", value: "-collectionName" },
                  ]}
                  setSelectedValue={(val) => {
                    setSort(val);
                  }}
                  dropdownClass={"min-w-[160px]"}
                />
              )}
            </div>
          )}
        </div>
        {filterOn && (
          <div className="mb-4 pb-4 border-b border-md-pink-light-1">
            <div className="flex items-center gap-1 md:gap-2 flex-wrap">
              <div className="relative w-full 3xl:w-auto min-w-72">
                <div className="h-10 aspect-square flex items-center justify-center absolute top-0 left-0 z-[1] text-base transition-all duration-300 text-md-pink">
                  <i className="fa-regular fa-magnifying-glass"></i>
                </div>
                <Search
                  placeholder={"Search here"}
                  search={(val) => {
                    setKeyword(val);
                    handleFilterChange("page", 0, setFilters);
                  }}
                  inputClasses="!h-10 !text-sm !pb-0.5 placeholder:!text-md-dark"
                />{" "}
              </div>
              <div className="ml-auto flex items-center gap-1 md:gap-2 w-full 3xl:w-auto">
                <div className="relative w-full 3xl:w-auto 3xl:min-w-52">
                  <DatePicker
                    value={dateRange}
                    range={true}
                    onChange={setDateRange}
                    placeholder="Select date range"
                  />
                </div>
                <div className="relative">
                  <Select
                    xPlacement={"bottomRight"}
                    selectedValue={status}
                    dropdownData={[
                      { name: "All Status", value: "All" },
                      { name: "Processing", value: "processing" },
                      { name: "Shipped", value: "shipped" },
                      { name: "Pickup", value: "pickup" },
                      { name: "Delivered", value: "delivered" },
                      { name: "Canceled", value: "canceled" },
                      { name: "Return Request", value: "returnRequest" },
                      { name: "Exchange Request", value: "exchangeRequest" },
                      { name: "Return Confirmed", value: "returnConfirmed" },
                      {
                        name: "Exchange Confirmed",
                        value: "exchangeConfirmed",
                      },
                    ]}
                    setSelectedValue={(val) => {
                      setStatus(val);
                    }}
                    dropdownClass={"min-w-[160px]"}
                  />
                </div>
                {/* <div className="relative">
                  <Select
                    xPlacement={"bottomRight"}
                    selectedValue={deliveryStatus}
                    dropdownData={[
                      { name: "All Delivery Status", value: "All" },
                      { name: "Awaiting", value: "Awaiting" },
                      { name: "Processing", value: "Processing" },
                      { name: "In Transit", value: "In Transit" },
                      { name: "Delivered", value: "Delivered" },
                      { name: "Cancelled", value: "Cancelled" },
                    ]}
                    setSelectedValue={(val) => {
                      setDeliveryStatus(val);
                    }}
                    dropdownClass={"min-w-[160px]"}
                  />
                </div> */}
              </div>
            </div>
          </div>
        )}
        <div className="relative flex justify-center items-center">
          {isLoading ? (
            <div className="flex items-center justify-center w-full h-[400px]">
              <span className="text-md-dark text-base">Fetching Data...</span>
            </div>
          ) : data?.data?.length > 0 ? (
            <div className="space-y-4">
              {data?.data?.map((item, index) => (
                <OrderItem key={index} data={item} />
              ))}
            </div>
          ) : (
            <div className="flex items-center justify-center  w-96  h-[400px]">
              {" "}
              <Image
                src={NodataImage}
                alt="no-data"
                className="w-full h-full object-contain"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OrderListing;
